module.exports = __webpack_public_path__ + "static/1189299509.8353897e.jpg";